// @flow
import type { Store } from 'effector'
import { Foxford } from '@foxford/foxford-js-sdk'
import { camelize } from 'utils/camelize'
import type { FeatureFlagName } from 'core/types'
import { BaseService } from '../base'
import type { WindowAppOptions, PhoneConfirmationType } from './types'
import { $appOptions, DEFAULT_APP_OPTIONS } from './model/store'
import { updateAppOptions } from './model/events'

class AppOptionsService<T: Store<WindowAppOptions>> extends BaseService<T> {
  /**
   * Stores the current state of the store
   */
  state: WindowAppOptions

  constructor(store: T) {
    super(store)

    store.watch((state) => {
      this.state = state
    })

    // В случае сборки для внешних ресурсов листеним обновление апп опшенз
    if (process.env.REACT_APP_EXTERNAL === 'true')
      window.addEventListener(Foxford.events.SET_APP_OPTIONS, this.onUpdateAppOptions)
  }

  onUpdateAppOptions = (event: CustomEvent) => {
    if (event.detail) updateAppOptions((event.detail: WindowAppOptions))
  }

  /**
   * Returns the initial state of app options
   */
  getInitialAppOptions = (): WindowAppOptions => {
    return camelize(window?.app_options || DEFAULT_APP_OPTIONS)
  }

  /**
   * Returns the current state of the store
   */
  getState(): WindowAppOptions {
    return this.state
  }

  /**
   * Returns type of phone confirmation
   */
  getPhoneConfirmationType(): PhoneConfirmationType {
    return this.state.phoneConfirmationType
  }

  /**
   * Returns a value of an AB-test experiment selected by it's id
   */
  getExperimentValue(experimentId: string): string | null {
    const { experiments = [] } = this.state
    const experiment = experiments.find(({ name }) => name === experimentId)

    return experiment?.value || null
  }

  /**
   * Checks exstence of the feature flag
   * @param {string} flag
   */
  checkFeaureFlagExistence = (flag: FeatureFlagName): boolean => {
    const { featureFlags = [] } = this.state
    const hasFlag = featureFlags.includes(flag)

    return hasFlag
  }
}

const aService = new AppOptionsService<Store<WindowAppOptions>>($appOptions)

export { aService as AppOptionsService }

export * from './types'
